const removeFormErrors = (form) => {
  form.closest('.olo-step-2').querySelector('.message.is-error').classList.add('is-hidden');

  Array.from(form.querySelectorAll('.form-error')).forEach((ele) => ele.remove());
};

const showUnexpectedError = (form) => {
  if (form.closest('.olo-step-2').querySelector('.message.is-error') !== null) {
    form.closest('.olo-step-2').querySelector('.message.is-error').classList.remove('is-hidden');
  }
};

const handleFormSuccess = () => {
  document.querySelector('#olo-step-3').style.display = 'block';
  document.querySelector('#olo-step-1').remove();
  document.querySelector('#olo-step-2').remove();
  document.querySelector('#olo-step-back').remove();
};

const handleFormSubmissionErrors = (form, response) => {
  if (response.errors) {
    Array.from(response.errors).forEach((error) => {
      const field = form.querySelector(`#form-row-${error.field}`);

      if (field) {
        const $error = document.createElement('span');
        $error.classList.add('form-error');
        $error.innerText = error.message;
        field.appendChild($error);
      }
    });

    return;
  }

  showUnexpectedError(form);
};

const handleFormSubmission = (event) => {
  event.preventDefault();
  const form = event.target;
  const formData = new FormData(form);
  removeFormErrors(form);
  const jsonData = {};

  /* eslint-disable no-restricted-syntax */
  for (const [key, value] of formData.entries()) {
    jsonData[key] = value;
  }
  /* eslint-enabled no-restricted-syntax */

  fetch(`${window.restUrl}on24/v1/register`, {
    method: 'POST',
    body: JSON.stringify(jsonData),
    headers: { 'Content-Type': 'application/json' },
  })
    .then((response) => response.json())
    .then((response) => {
      if (response.status !== 'success') {
        handleFormSubmissionErrors(form, response);
        return;
      }

      handleFormSuccess(response);
    })
    .catch(() => showUnexpectedError(form));
};

const setUpEvents = () => {
  const forms = document.querySelectorAll('.olo-form');
  Array.from(forms).forEach((form) => {
    form.addEventListener('submit', handleFormSubmission);
  });
};

const changeContinue = (state) => {
  const oloContinue = document.getElementById('olo-continue');

  if (state !== 'disabled') {
    oloContinue.classList.remove('disabled');
    return;
  }

  oloContinue.classList.add('disabled');
};

const selectEpisode = (selectedCheckbox) => {
  const eventID = selectedCheckbox.getAttribute('for');
  const eventCheckbox = document.getElementById(eventID);
  const eventValue = eventCheckbox.checked;
  const episodeName = eventCheckbox.getAttribute('name');

  // Uncheck all current Episodes checkboxes
  for (let a = 1; a < 3; a += 1) {
    if (episodeName === `episode-${a}`) {
      const episode = document.querySelectorAll(`[name="episode-${a}"]`);
      Array.from(episode).forEach((checkbox) => {
        checkbox.checked = false; // eslint-disable-line no-param-reassign
      });
    }
  }

  // Choose selected checkbox if wasn't checked
  if (eventValue) {
    eventCheckbox.checked = true;

    // Updates event meta
    const eventMeta = document.querySelector(`#eventmeta_${eventID} p`).innerHTML;
    document.getElementById(`eventregmeta_${episodeName}`).innerHTML = eventMeta;
    if (episodeName === 'episode-1') {
      document.getElementById(`eventmeta_${episodeName}`).innerHTML = eventMeta;
    } else {
      document.getElementById(`eventmeta_${episodeName}`).innerHTML = eventMeta;
    }

    // Check if ep1 and ep2 have content to add in the &.
    if (
      !!document.getElementById(`eventmeta_episode-1`).innerHTML &&
      !!document.getElementById(`eventmeta_episode-2`).innerHTML
    ) {
      document.getElementById('eventmeta_separator').innerHTML = '&';
    }

    document.getElementById(`eventregmeta_wrap_${episodeName}`).style.display = 'block';
  } else {
    // Remove event meta
    document.getElementById(`eventmeta_${episodeName}`).innerHTML = '';
    document.getElementById(`eventregmeta_${episodeName}`).innerHTML = '';
    document.getElementById('eventmeta_separator').innerHTML = '';
    document.getElementById(`eventregmeta_wrap_${episodeName}`).style.display = 'none';
  }

  // Change continue button if selection exists for all Episodes
  const episodesSelected = [];
  const episodesIds = [];
  for (let b = 1; b < 3; b += 1) {
    const episode = document.querySelectorAll(`[name="episode-${b}"]`);
    episodesSelected[`episode-${b}`] = [];
    Array.from(episode).forEach((checkbox) => {
      episodesSelected[`episode-${b}`].push(checkbox.checked);
      if (checkbox.checked) {
        episodesIds.push(checkbox.value);
      }
    });
  }

  // Updates multievent_ids input
  document.getElementById('multievent_ids').value = episodesIds;

  for (let c = 1; c < 3; c += 1) {
    if (episodesSelected[`episode-${c}`].includes(true)) {
      changeContinue('enabled');
      return;
    }
  }
  changeContinue('disabled');
};

const setUpEpisodes = () => {
  // Adds listener for all Episode checkboxes
  for (let d = 1; d < 3; d += 1) {
    const episode = document.querySelectorAll(`.episode-${d}`);
    Array.from(episode).forEach((checkbox) => {
      // Run the select incase there's any pre-selected in the template.
      selectEpisode(checkbox);

      checkbox.addEventListener('click', function clickEpisode() {
        selectEpisode(this);
      });
    });
  }
};

const setUpButtons = () => {
  // Adds listener for continue button
  if (document.getElementById('olo-continue')) {
    document.getElementById('olo-continue').addEventListener('click', () => {
      document.querySelector('#olo-step-2').style.display = 'block';
      document.querySelector('#olo-step-back').style.display = 'block';
      document.querySelector('#olo-step-1').style.display = 'none';
    });
  }

  // Adds listener for back button
  if (document.getElementById('olo-back')) {
    document.getElementById('olo-back').addEventListener('click', () => {
      document.querySelector('#olo-step-2').style.display = 'none';
      document.querySelector('#olo-step-back').style.display = 'none';
      document.querySelector('#olo-step-1').style.display = 'block';
    });
  }

  // Adds listener for headset button
  if (document.getElementById('headset')) {
    document.getElementById('headset').addEventListener('click', () => {
      if (this.checked === true) {
        document.querySelector('#headset-address').style.display = 'block';
      } else {
        document.querySelector('#headset-address').style.display = 'none';
        // Clear address fields
        document.getElementById('addressstreet1').value = '';
        document.getElementById('addressstreet2').value = '';
        document.getElementById('city').value = '';
        document.getElementById('zip').value = '';
      }
    });
  }
};

setUpEvents();
setUpEpisodes();
setUpButtons();
